import React from 'react';
import Text from 'components/Text/Text';

export const ArchivedLabel: React.FC = () => (
	<Text
		className="!text-grey-06-new ml-1"
		size="xs"
		display="inline"
		translationNameSpace="listing"
		translationKey="archivedItemLabel"
	/>
);
